import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { Skeleton } from '@material-ui/lab';
import Content from './Content';

const MaxLossesAndReturnsSection = ({ resource }) => {
  const [data, setData] = useState();

  useEffect(() => {
    async function getModelPerformanceData() {
      if (resource) {
        try {
          const [newData] = await resource.relationship(fr.relationships.modelPerformanceData.name).link('related').get();
          setData(newData);
        } catch (e) {
          displayErrorMessage(e, 'Failed to fetch "Max Losses And Returns"');
        }
      }
    }

    getModelPerformanceData();
  }, [resource]);

  if (!data) {
    return <Skeleton width={368} height={200} />;
  }

  return (
    <Content
      oneYearMaxLoss={data.attr('oneYearMaxLoss')}
      threeYearMaxAnnualizedLosses={data.attr('threeYearMaxAnnualizedLosses')}
      averageAnnualReturn={data.attr('averageAnnualReturn')}
      threeYearMaxAnnualizedReturn={data.attr('threeYearMaxAnnualizedReturn')}
      oneYearMaxReturn={data.attr('oneYearMaxReturn')}
      disclaimer={data.attr('maxLossesAndReturnsDisclaimer')}
      disclaimerReadMore={data.attr('maxLossesAndReturnsDisclaimerReadMore')}
    />
  );
};

MaxLossesAndReturnsSection.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default MaxLossesAndReturnsSection;
